import TemplateView from "../../TemplateView"

export default class InformationBlockLine extends TemplateView {
    constructor({
        lineText = '',
    }) {
        super()
        this.lineText = lineText
    }

    templateHtml() {
        return '<div class="informationBlockLine">' +
               '    <div class="iconPlaceholder"/>' +
               '    <div class="text"><%-lineText%></div>' +
               '</div>'
    }
}



// WEBPACK FOOTER //
// ./web/js/components/informationBlock/InformationBlockLine.js